const state = {
  visible: false,
  message: '',
}

const mutations = {
  error_show: function (state, payload) {
    state.message = payload
    state.visible = true
    window.scrollTo(0,0)
  },
  error_dismiss: function (state) {
    state.message = ''
    state.visible = false
  }
}

export default {state, mutations}



// WEBPACK FOOTER //
// ./src/store/modules/error.js